export class BaseAuthCriteriaModel {
  orderBy ? = 'guid';
  offset ? = 0;
  limit ? = 100;
  order ? = 'ASC';
}
